module.exports = __webpack_public_path__ + "static/media/Melissa Schmidt.2f627c9b.jpg";